import { withStateMachine } from "react-automata";

export default (statechart, options = {}) => Component =>
  withStateMachine(statechart, { channel: Component.name, ...options })(
    Component
  );
